import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { IError, IServerErrorResponse } from '../../types';

interface IPayload {
    customerId:string;
    linkedAccountId: string;
    amount: string;
}

interface IResponse {
    transactionId: string;
}

export const useSendMoneyMutation = ({ customerId, linkedAccountId, amount }: IPayload, onSuccess: (trxId: string)=> void, onError: (data: IError)=> void) => {
  let parsedAmount = 0;
  try {
    parsedAmount = JSON.parse(amount
      .replace('$', '')
      .replaceAll(',', '')
      .replaceAll(' ', ''));
  } catch (e) {
    console.error(e);
    parsedAmount = 0;
  }
  return useMutation(
    'sendMoney',
    async () => {
      const { data } = await httpService.post(`${BASE_URL}/api/v2/user/${customerId}/payTo/${linkedAccountId}`, {
        amount: parsedAmount,
      });
      return data;
    },
    {
      onSuccess: ({ transactionId }:IResponse) => {
        onSuccess(transactionId);
      },
      onError: (e: IServerErrorResponse) => {
        onError(e.response.data.errors[0]);
      },
    },
  );
};
